import { normalize } from 'normalizr'
import { fromJS } from 'immutable'
import { formatStrategy, schemaDevice } from '../schemas'
import axios from 'axios'

/**
 * 获取分组的应用策略
 * @param {*String} groupId 分组id
 */
export const findStrategyInGroup = async (groupId) => {
  let productId = sessionStorage.getItem('productType')
  let path = `v2/solar-mote-strategys/strategy-group/${groupId}`
  if (productId === '16') {
    path = `repower/${path}`
  }
  const { data } = await axios.get(path)
  const strategy = formatStrategy(data)
  return fromJS({ [groupId]: strategy })
}

/**
 * 获取设备的应用策略
 * @param {*String} deviceId 设备id
 */
export const findStrategyInDevice = async (deviceId) => {
  let productId = sessionStorage.getItem('productType')
  let path = `v2/solar-mote-strategys/solar-mote/${deviceId}`
  if (productId === '8') {
    path = `v2/solar-mote-strategys/solar-mote-list/${deviceId}`
  }
  if (productId === '16') {
    path = `repower/${path}`
  }
  const { data } = await axios.get(path)
  if (productId === '8') {
    path = `v2/solar-mote-strategys/solar-mote-list/${deviceId}`
    const strategy = data.map(item => formatStrategy(item))
    return fromJS({ [deviceId]: strategy })
  } else {
    const strategy = [formatStrategy(data)]
    return fromJS({ [deviceId]: strategy })
  }
}

/**
 * 对设备下发参数
 * @param {*String} options.id 设备id
 * @param {*Number} options.paramSettingMode 参数设置模式,1-默认；2-自定义（如果电池电压选其他此参数值则为2-自定义，否则为1-默认）
 * @param {*Number} options.batteryType 电池类型（1-磷酸铁锂；2-三元锂；3-铅酸；）
 * @param {*Number} options.batteryVoltage 电池电压（如电池类型选中磷酸铁锂有12V，24V，其他）
 * @param {*Number} options.batteryOverVoltage 电池超压电压（用于充电停止电压），单位：V
 * @param {*Number} options.batteryOverToBackVoltage 电池超压恢复电压，单位：V
 * @param {*Number} options.batteryLowVoltage 电池低压电压（用于停止亮灯电压），单位：V
 * @param {*Number} options.batteryLowToBackVoltage 电池低压恢复电压，单位：V
 * @param {*Number} options.ledRatedCurrent LED灯额定电流，单位：A
 * @param {*Number} options.dayThreshold 光控天亮阈值，单位：V
 * @param {*Number} options.nightThreshold 光控天黑阈值，单位：V
 * @param {Number} options.strongChargeVoltage 强充电压，单位：V
 * @param {Number} options.evenChargeVoltage 均衡充电压，单位：V
 * @param {Number} options.floatChargeVoltage 浮充电压，单位：V
 */
export const updateConfig = async (options) => {
  let productId = sessionStorage.getItem('productType')
  let path = `v2/device-downs/set-param/${options.id}`
  if (productId === '16') {
    path = `repower/v2/repower-device-downs/set-param/${options.id}`
  }
  const { data: { detail } } = await axios.post(path, options)
  const { entities } = normalize(detail, schemaDevice)
  return fromJS(entities)
}

/**
 * 对分组下发策略
 * @param {*String} groupId 分组id
 * @param {*String} strategyId 策略id
 */
export const updateGroupStrategy = async (groupId, strategyId) => {
  let productId = sessionStorage.getItem('productType')
  let path = `v2/device-downs/set-strategy-to-group/${groupId}`
  if (productId === '16') {
    path = `repower/v2/repower-device-downs/set-strategy-to-group/${groupId}`
  }
  if (Array.isArray(strategyId)) {
    await axios.post(path, { strategyTemplateIds: strategyId })
  } else {
    await axios.post(path, { strategyTemplateId: strategyId })
  }
}

/**
 * 对设备下发策略
 * @param {*String} deviceId 设备id
 * @param {*String} strategyId 策略id
 */
export const updateDeviceStrategy = async (deviceId, strategyId) => {
  let productId = sessionStorage.getItem('productType')
  let path = `v2/device-downs/set-strategy/${deviceId}`
  if (productId === '16') {
    path = `repower/v2/repower-device-downs/set-strategy/${deviceId}`
  }
  await axios.post(path, { strategyTemplateId: strategyId })
}

/**
 * 设置分组
 * @param {*String} projectId 项目id
 * @param {*String} groupId 分组id
 * @param {*Array} deviceId 修改后分组内的设备id列表
 */
export const updateInGroup = async (projectId, groupId, deviceId) => {
  let productId = sessionStorage.getItem('productType')
  let path = `v2/device-downs/set-switch-time-strategy-group-pc/${groupId}?projectId=${projectId}`
  if (productId === '16') {
    path = `repower/${path}`
  }
  const { data } = await axios.post(path, { solarMoteIds: deviceId })
  return data
}

/**
 * 启用设备
 * @param {*String} projectId 项目id
 * @param {*Array} deviceId 设备id
 */
const enableDevice = async (projectId, deviceId) => {
  let productId = sessionStorage.getItem('productType')
  let path = `v2/solar-motes/enable?projectId=${projectId}`
  if (productId === '16') {
    path = `repower/${path}`
  }
  const res = await axios.put(path, { solarMoteIds: deviceId })
  return res
}

/**
 * 停用设备
 * @param {*String} projectId 项目id
 * @param {*Array} deviceId 设备id
 */
const disableDevice = async (projectId, deviceId) => {
  let productId = sessionStorage.getItem('productType')
  let path = `v2/solar-motes/disable?projectId=${projectId}`
  if (productId === '16') {
    path = `repower/${path}`
  }
  const res = await axios.put(path, { solarMoteIds: deviceId })
  return res
}

/**
 * 启用、停用设备（批量）
 * @param {*String} projectId 项目id
 * @param {*Array} deviceId 设备id
 * @param {*String} type 更新后的状态，可选值（enable, disable）
 */
const mapDeviceState = {
  enable: enableDevice,
  disable: disableDevice
}
export const updateDeviceState = async (projectId, deivceId, type) => {
  const handler = mapDeviceState[type]
  if (typeof handler !== 'function') {
    throw new Error('参数错误！type 可选值错误: [enable, disable]')
  }
  const { data: { detail } } = await handler(projectId, deivceId)
  return detail
}

/**
 * 删除设备（批量）
 * @param {*String} deviceId 设备id
 * @param {*String} password 密码
 */
export const destroyByIds = async (projectId, deviceId, password) => {
  let productId = sessionStorage.getItem('productType')
  let path = `v2/solar-motes/unactivated-batch?projectId=${projectId}`
  if (productId === '16') {
    path = `repower/${path}`
  }
  await axios.post(path, { solarMoteIds: deviceId, password: password })
}

/**
 * 更新设备状态，如电压电流值（批量）
 * @param {*String} projectId 项目id
 * @param {*String} deviceId 设备id
 */
export const updateStatus = async (projectId, deviceId) => {
  let productId = sessionStorage.getItem('productType')
  let path = `v2/device-downs/get-status-batch?projectId=${projectId}`
  if (productId === '16') {
    path = `repower/v2/repower-device-downs/get-status-batch?projectId=${projectId}`
  }
  await axios.post(path, { solarMoteIds: deviceId })
}

/**
 * 单个更新设备状态
 * @param {*String} deviceId 设备id
 */
export const updateStatusBySingle = async (deviceId) => {
  let productId = sessionStorage.getItem('productType')
  let path = `v2/device-downs/get-status/${deviceId}`
  if (productId === '16') {
    path = `repower/v2/repower-device-downs/get-status/${deviceId}`
  }
  await axios.post(path)
}

/**
 * 开、关、调光（批量）
 * @param {*String} projectId 项目id
 * @param {*Array} deviceId 设备id
 * @param {*String} type 操作类型，可选值：open, close, dimme
 * @param {Number} brightness 亮度 调光时，需要该参数
 */
const mapDimmeType = {
  open: 1,
  close: 2,
  dimme: 3
}
export const dimmeLevel = async (projectId, deviceId, type, brightness) => {
  const switchState = mapDimmeType[type]
  let productId = sessionStorage.getItem('productType')
  let path = `v2/device-downs/switch-control-batch?projectId=${projectId}`
  if (productId === '16') {
    path = `repower/v2/repower-device-downs/switch-control-batch?projectId=${projectId}`
  }
  await axios.post(path, { switchState, brightness, solarMoteIds: deviceId })
}

/**
 * 开、关、调光（单个）
 * @param {*String} projectId 项目id
 * @param {*Array} deviceId 设备id
 * @param {*String} type 操作类型，可选值：open, close, dimme
 * @param {Number} brightness 亮度 调光时，需要该参数
 */
export const dimmeLevelBySingle = async (deviceId, type, brightness) => {
  const switchState = mapDimmeType[type]
  let productId = sessionStorage.getItem('productType')
  let path = `v2/device-downs/switch-control/${deviceId}`
  if (productId === '16') {
    path = `repower/v2/repower-device-downs/switch-control/${deviceId}`
  }
  await axios.post(path, { switchState, brightness })
}
/**
 * 批量充电，取消充电
 */
export const chargeBatch = async (projectId, solarMoteIds, type) => {
  const path = `/v1/solar-motes/putPowerSwitchBatch?projectId=${projectId}`
  await axios.put(path, { solarMoteIds, type })
}
/**
 *分组下发充电、断电
 * @param {*String} groupId  分组id
 * @param {*} type 状态
 * @param {*} projectId 项目id
 */
export const groupCharging = async (projectId, groupId, type) => {
  const path = `/v1/solar-motes/putPowerSwitchGroup?projectId=${projectId}`
  await axios.put(path, { groupId, type })
}
/**
 * 对分组进行开关、调光
 * @param {*String} groupId 分组id
 * @param {*Number} switchState 状态 1-开、2-关、3-调光
 * @param {*Number} brightness 亮度 调光时，需要该参数
 */
export const dimmeInGroup = async (groupId, switchState, brightness) => {
  let productId = sessionStorage.getItem('productType')
  let path = `v2/device-downs/switch-control-group/${groupId}`
  if (productId === '16') {
    path = `repower/v2/repowerdevice-downs/switch-control-group/${groupId}`
  }
  await axios.post(path, { switchState, brightness })
}

/**
 * 批量下发智能功率参数
 * @param {*String} projectId 项目id
 * @param {*String} solarMoteIds 设备id数组
 * @param {*Number} batteryType 电池类型（1-磷酸铁锂；2-三元锂；3-铅酸；）
 * @param {*String} voltagePointIntervals 智能功率参数区间
 */
export const setPowerParamInBatch = async (projectId, solarMoteIds, batteryType, voltagePointIntervals) => {
  const { data } = await axios.post(`v2/device-downs/set-lower-led-param-batch?projectId=${projectId}`, { solarMoteIds, batteryType, voltagePointIntervals })
  return data.detail
}

/**
 * 批量下发零度充电方式
 * @param {*String} projectId 项目id
 * @param {*String} solarMoteIds 设备id数组
 * @param {*String} zeroChargeType 锂电池零度充电方式；0-正常充电；1-不充电；2-慢充电
 */
export const setZeroChargeTypeInBatch = async (projectId, solarMoteIds, zeroChargeType) => {
  const { data } = await axios.post(`v2/device-downs/set-zero-charge-type-batch?projectId=${projectId}`, { solarMoteIds, zeroChargeType })
  return data.detail
}

/**
 * 对设备下发人流量参数
 * @param {*String} deviceId 设备id
 * @param {*Number} trafficControl 人流量开关 0-关闭；1-开启
 */
export const updateTrafficParam = async (deviceId, trafficControl) => {
  const { data } = await axios.post(`v2/device-downs/set-traffic-param/${deviceId}`, { trafficControl })
  return data
}

/**
 * 对设备下发切换电源电压
 * @param {*String} deviceId 设备id
 * @param {*Number} switchingPowerSupplyVoltage 切换电源电压
 */
export const updatePowerSupplyVol = async (deviceId, switchingPowerSupplyVoltage) => {
  const { data } = await axios.post(`v2/device-downs/set-power-supply-voltage/${deviceId}`, { switchingPowerSupplyVoltage })
  return data
}

/**
 * 设置休眠状态（后面跟的是设备id）
 * @param {*String} deviceId 设备id
 * @param {*Number} sleepState 0-唤醒；1-休眠（非光控唤醒）；2-休眠（光控唤醒）
 */
export const updateSleepStateById = async (deviceId, sleepState) => {
  let productId = sessionStorage.getItem('productType')
  let path = `v2/repower-device-downs/set-sleep-state/${deviceId}`
  if (productId === '16') {
    path = `repower/${path}`
  }
  const { data } = await axios.post(path, { sleepState })
  return data
}

/**
 * 设置休眠状态（后面跟的是分组id）
 * @param {*String} groupId 分组id
 * @param {*Number} sleepState 0-唤醒；1-休眠（非光控唤醒）；2-休眠（光控唤醒）
 */
export const updateSleepStateByGroupId = async (groupId, sleepState) => {
  let productId = sessionStorage.getItem('productType')
  let path = `v2/repower-device-downs/set-sleep-state-group/${groupId}`
  if (productId === '16') {
    path = `repower/${path}`
  }
  const { data } = await axios.post(path, { sleepState })
  return data
}

/**
 * 流量开关（后面跟的是设备id）
 * @param {*String} deviceId 设备id
 * @param {*String} fourthGenerationFlowSwitchState 4G流量开关；1-开启 0-关闭；
 */
export const updateNetworkBySingle = async (deviceId, networkType) => {
  let productId = sessionStorage.getItem('productType')
  let path = `v2/device-downs/fourth-generation-flow-switch-control/${deviceId}`
  if (productId === '16') {
    path = `repower/v2/device-downs/fourth-generation-flow-switch-control/${deviceId}`
  }
  await axios.post(path, { fourthGenerationFlowSwitchState: networkType })
}

/**
 * 流量开关（后面跟的是分组id）
 * @param {*String} groupId 设备id
 * @param {*String} fourthGenerationFlowSwitchState 4G流量开关；1-开启 0-关闭；
 */
export const updateNetworkByGroup = async (deviceId, networkType) => {
  let productId = sessionStorage.getItem('productType')
  let path = `v2/device-downs/fourth-generation-flow-switch-control-group/${deviceId}`
  if (productId === '16') {
    path = `repower/v2/device-downs/fourth-generation-flow-switch-control-group/${deviceId}`
  }
  await axios.post(path, { fourthGenerationFlowSwitchState: networkType })
}

/**
 * 设置充电/不充电
 * @param {*String} projectId 所属项目id
 * @param {*String} options.moteId 设备ID
 * @param {*type} options.type 1-充电/0-不充电
 */
export const putPowerSwitch = async (projectId, options) => {
  await axios.put(`v1/solar-motes/putPowerSwitch?projectId=${projectId}`, {
    moteId: options.deviceId,
    type: options.type
  })
}
/**
 * 读取设备固件名
 */
export const readFirmware = async (data) => {
  let productType = sessionStorage.getItem('projectProductType')
  let url = `v1/firmwares/read-firmware`
  if (productType === '16') {
    url = `repower/v1/firmwares/read-firmware`
  }
  const result = await axios.post(url, {
    snHex: data.snHex
  })
  return result
}
/**
 * 获取LED端保护电流
 */

export const getLedProtectedCurrent = async (data) => {
  let productType = sessionStorage.getItem('projectProductType')
  let url = `v1/sys-downs/get-led-protected-current`
  if (productType === '16') {
    url = `repower/v1/sys-downs/get-led-protected-current`
  }
  const result = await axios.post(url, {
    snHex: data.snHex
  })
  return result
}
/**
 * 设置LED端保护电流
 */

export const setLedProtectedCurrent = async (data) => {
  let productType = sessionStorage.getItem('projectProductType')
  let url = `v1/sys-downs/set-led-protected-current`
  if (productType === '16') {
    url = `repower/v1/sys-downs/set-led-protected-current`
  }
  const result = await axios.post(url, {
    snHex: data.snHex,
    differenceValue: data.differenceValue
  })
  return result
}
/**
 * 设置设备的时间-对时
 */
export const setTime = async (snHex) => {
  let productType = sessionStorage.getItem('projectProductType')
  let url = `/v1/sys-downs/set-time`
  if (productType === '16') {
    url = `repower/v1/sys-downs/set-time`
  }
  const result = await axios.post(url, {
    snHex
  })
  return result
}
/**
 * 获取LED过流保护
 */
export const getLEDCurrProfect = async (data) => {
  let productType = sessionStorage.getItem('projectProductType')
  let url = `v1/sys-downs/get-over-current`
  if (productType === '16') {
    url = `repower/v1/sys-downs/get-over-current`
  }
  const result = await axios.post(url, data)
  return result
}
/**
 * 设置LED过流保护
 */
export const setLEDCurrProfect = async (data) => {
  let productType = sessionStorage.getItem('projectProductType')
  let url = `v1/sys-downs/set-over-current`
  if (productType === '16') {
    url = `repower/v1/sys-downs/set-over-current`
  }
  const result = await axios.post(url, data)
  return result
}
